<template>
    <div>
        <websocket-watcher
            :channel="wsChannel"
            @message="handleMessage"
            @connected="setConnectedToRealtimeService"
        />
        <div class="inline">
            <page-headline>{{$t('pages.dashboard.index.dashboard')}}</page-headline>
        </div>

        <div class="flex flex-wrap mt-5">
            <div class="w-full md:w-1/2 xl:w-1/3 p-3">
                <div class="bg-gray-100 border-b-2">
                    <div class="flex flex-row items-center px-5 py-1 bg-gray-200">
                        <div class="flex-1 text-right md:text-center">
                            <span class="font-medium text-xs uppercase">{{$t('pages.dashboard.index.running_auctions')}}</span>
                            <h3 class="font-medium text-3xl">{{this.countRunningAuctions()}} / {{this.sumBids()}} / {{this.sumCustomers()}}</h3>
                            <span class="font-medium text-xs uppercase">{{$t('pages.dashboard.index.auctions_bids_customers')}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="this.audiencesState.length > 0">
            <div class="mt-5">
                <h2 class="text-lg leading-6 font-medium text-gray-900">{{$t('pages.dashboard.index.active_users')}}</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 p-3">
                        <audience-panel
                            v-for="audience in audiencesState"
                            :key="audience.id"
                            :audience="audience"
                            :update-count="audienceUpdateCount"
                        />
                    </div>
            </div>
        </template>
    </div>

</template>

<script>
    import Layout from '@/Shared/Layout';
    import PageHeadline from '@/Shared/PageHeadline';
    import WebsocketWatcher from "@/Shared/WebsocketWatcher";
    import AudiencePanel from "./Components/AudiencePanel";
    import AuctionsCount from "./Components/AuctionsCount";
    import Icon from '@/Shared/Icon';

    export default {
        layout: Layout,
        components: {
            PageHeadline,
            Icon,
            WebsocketWatcher,
            AudiencePanel,
            AuctionsCount,
        },
        props: {
            auctions: Object,
            auction: Object,
            wsChannel: {
                type: String,
                default: null
            },
            audiences: {
                type: Array,
                default: null
            }
        },
        data() {
          return {
              updatedAudiences: [],
              updateCount: 0,
              /**
               * Connection to ably established? Being set by event from websocketWatcher component
               */
              connected: false
          };
        },
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.index.dashboard')
            }
        },
        computed: {
            audiencesState() {
                if (this.updatedAudiences.length > 0) {
                    return this.updatedAudiences;
                }
                return this.audiences;
            },
            audienceUpdateCount() {
                return this.updateCount;
            }
        },
        methods: {
            handleMessage(e) {
                if (e.name === 'WebsocketChannelStatsUpdated') {
                    // Increase updateCount (forces data reload in the audience components)
                    this.updateCount++;
                }
            },
            setConnectedToRealtimeService(status) {
                this.connected = status;
            },
            countRunningAuctions() {
                return this.auctions.stats.auctions_quantity;
            },
            sumBids() {
              return this.auctions.stats.bids_quantity;
            },
            sumCustomers() {
              return this.auctions.stats.unique_customers;
            }
        },
    }
</script>
